export const theme = {
  bg: '#0C0E12', bgPanel: '#13161B', bgCard: '#171A20', bgHover: '#1D2128',
  border: '#23272F', borderLight: '#2A2F38', text: '#F2F1ED',
  textMuted: '#9B9A93', textFaint: '#6B6A64', accent: '#7C7AE8',
  accentDark: '#5B58C9', accentBg: 'rgba(124,122,232,0.12)',
  success: '#5DCAA5', warning: '#EF9F27', danger: '#E24B4A',
  radius: 10, radiusSm: 7,
};
export const fileTypeColor = (ext) => {
  const map = {
    PDF:'#E24B4A',DOC:'#378ADD',DOCX:'#378ADD',XLS:'#5DCAA5',XLSX:'#5DCAA5',
    PPT:'#EF9F27',PPTX:'#EF9F27',PNG:'#D4537E',JPG:'#D4537E',JPEG:'#D4537E',
    MP4:'#7C7AE8',MOV:'#7C7AE8',ZIP:'#9B9A93',TXT:'#9B9A93',PSD:'#378ADD',
  };
  return map[ext] || '#7C7AE8';
};
